import { clsx, type ClassValue } from "clsx";
import { AssetAmount } from "@sundaeswap/asset";

export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}

/**
 * Format an ADA balance for display. Handles both AssetAmount (which may
 * have decimals=0 if metadata hasn't resolved yet) and raw lovelace bigints.
 */
export function formatAda(balance: AssetAmount): string {
  // If decimals are correct (6), use the Fraction value directly
  if (balance.decimals === 6) {
    return balance.value.toNumber(2).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 6,
    });
  }
  // Otherwise, treat amount as raw lovelace
  const ada = Number(balance.amount) / 1_000_000;
  return ada.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 6,
  });
}

export function formatLovelace(lovelace: string | bigint): string {
  const value = typeof lovelace === "string" ? BigInt(lovelace) : lovelace;
  const ada = Number(value) / 1_000_000;
  return ada.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 6,
  });
}

export function shortenAddress(address: string, chars = 8): string {
  return `${address.slice(0, chars)}...${address.slice(-chars)}`;
}
